import type {Annotation} from "@mytour/ui/form";
import {AnnotationSchema, ImageAnnotation} from "@mytour/ui/form";
import type {UseFormReturn} from "react-hook-form";
import z from "zod";

export const step5Schema = z.object({
  annotations: z.array(AnnotationSchema),
  imageData: z.string().optional(),
});

export type Step5Form = z.infer<typeof step5Schema>;

type Props = {
  hookForm: UseFormReturn<Step5Form>;
  disabled: boolean;
  closing: boolean;
};

export function Step5({hookForm, disabled, closing}: Props) {
  const annotations = hookForm.watch("annotations");
  return (
    <ImageAnnotation
      title="Annotations des postérieurs"
      imagePath="/images/podologie/POST.png"
      values={annotations}
      onChange={handleChange}
      onUpdateImage={handleUpdateImage}
      disabled={disabled}
      closing={closing}
    />
  );

  function handleChange(annotations: Annotation[]) {
    hookForm.setValue("annotations", annotations);
  }

  function handleUpdateImage(imageData: string) {
    hookForm.setValue("imageData", imageData);
  }
}
